import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setCanvasSize } from '../../../../redux/canvasSize/canvasSizeSlice';
import './canvasResizerMenu.scss';

export default function CanvasResizerMenu(props) {
    const [canvasSizeBaseArr, setCanvasSizeBaseArr] = useState([600, 450]);
    const [newCanvasWidth, setNewCanvasWidth] = useState('');
    const [newCanvasHeight, setNewCanvasHeight] = useState('');

    const dispatch = useDispatch();
    const activeTabId = useSelector((state) => state.tabs.activeTabId);

    const handlerCloseCanvasResize = () => {
        dispatch(setCanvasSize({ tabID: activeTabId, size: canvasSizeBaseArr }));
        props.canvasResizerMenuToggle();
    }

    const handlerResetCanvasResize = () => {
        setNewCanvasWidth(canvasSizeBaseArr[0]);
        setNewCanvasHeight(canvasSizeBaseArr[1]);
        dispatch(setCanvasSize({ tabID: activeTabId, size: canvasSizeBaseArr }));
    }

    const handleSetNewCanvasSize = () => {
        if ((newCanvasWidth >= 100 && newCanvasHeight >= 100) && (newCanvasWidth < 10000 && newCanvasHeight < 10000)) {
            dispatch(setCanvasSize({ tabID: activeTabId, size: [newCanvasWidth, newCanvasHeight] }));
            props.canvasResizerMenuToggle();
        }
    }

    const handleSetNewCanvasWidth = (e) => {
        if (/^\d*$/.test(e.target.value)) {
            setNewCanvasWidth(+e.target.value);
        }
    }

    const handleSetNewCanvasHeight = (e) => {
        if (/^\d*$/.test(e.target.value)) {
            setNewCanvasHeight(+e.target.value);
        }
    }

    useEffect(() => {
        console.log(activeTabId)
    }, [])

    // useEffect(() => {
    //     setNewCanvasWidth(canvasSize.payload.canvasSize.canvasSize[0]);
    //     setNewCanvasHeight(canvasSize.payload.canvasSize.canvasSize[1]);
    // }, [canvasSize])

    return(
        <section className="canvas-resizer-menu_section">
            <header className="canvas-resizer-menu_header">
                <div className="canvas-resizer-menu_header-block">
                    <h3 className="canvas-resizer-menu_header-title">Resize canvas</h3>
                    <button className="canvas-resizer-menu_close-btn" onClick={handlerCloseCanvasResize}>&times;</button>
                </div>
            </header>
            <section className="canvas-resizer-menu_input-section">
                <label className="canvas-resizer-menu_input-label" htmlFor="canvasResizerMenuInputWidth">
                    Width:
                </label>
                <input
                    type="text"
                    id="canvasResizerMenuInputWidth"
                    className="canvas-resizer-menu_input"
                    value={newCanvasWidth}
                    onChange={handleSetNewCanvasWidth}
                ></input>
                <label className="canvas-resizer-menu_input-label canvas-resizer-menu_input-label-height" htmlFor="canvasResizerMenuInputHeight">
                    Height:
                </label>
                <input
                    type="text"
                    id="canvasResizerMenuInputHeight"
                    className="canvas-resizer-menu_input"
                    value={newCanvasHeight}
                    onChange={handleSetNewCanvasHeight}
                ></input>
            </section>
            <section className="canvas-resizer-menu_button-section">
                <div className="canvas-resizer-menu_btns">
                    <button className="canvas-resizer-menu_btn canvas-resizer-menu_cancel-btn" onClick={handlerResetCanvasResize}>Reset</button>
                    <button className="canvas-resizer-menu_btn canvas-resizer-menu_ok-btn" onClick={handleSetNewCanvasSize}>Ok</button>
                </div>
            </section>
        </section>
    )
}